import React from "react";
import CmsForm from "./CmsForm";

function CmsCustom({ component, page_id = "" }) {
  if (component.id == "mappa-sede-1") {
    return (
      <iframe
        frameBorder="0"
        scrolling="no"
        marginHeight="0"
        marginWidth="0"
        src="https://maps.google.com/maps?q=BozImex%20Italia&amp;t=m&amp;z=8&amp;output=embed&amp;iwloc=near"
        title="BozImex Italia"
        aria-label="BozImex Italia"
        className="w-full h-full"
      ></iframe>
    );
  } else if (component.id == "mappa-sede-2") {
    return (
      <iframe
        frameBorder="0"
        scrolling="no"
        marginHeight="0"
        marginWidth="0"
        src="https://maps.google.com/maps?q=Mata%C4%8Di%C4%87eva%201%2C%20Rijeka&amp;t=m&amp;z=8&amp;output=embed&amp;iwloc=near"
        title="Matačićeva 1, Rijeka"
        aria-label="Matačićeva 1, Rijeka"
        className="w-full h-full"
      ></iframe>
    );
  } else if (component.id == "mappa-sede-3") {
    return (
      <iframe
        frameBorder="0"
        scrolling="no"
        marginHeight="0"
        marginWidth="0"
        src="https://maps.google.com/maps?q=Str.%20Ion%20C%C3%A2mpineanu%20nr.%2013%2C%20010032%20Bucuresti%20-%20Sector%201&amp;t=m&amp;z=6&amp;output=embed&amp;iwloc=near"
        title="Str. Ion Câmpineanu nr. 13, 010032 Bucuresti - Sector 1"
        aria-label="Str. Ion Câmpineanu nr. 13, 010032 Bucuresti - Sector 1"
        className="w-full h-full"
      ></iframe>
    );
  } else if (component.id == "contact-form") {
    return (
      <CmsForm
        component={component}
      />
    );
  } else {
    return <div className={`custom-block`} id={`${component.id ?? ""}`} />;
  }
}

export default CmsCustom;
